import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import CheckSerasaCobranca from '../pages/financeiro/checkSerasaCobranca';
import CriarContrato from '../pages/financeiro/criarContrato';
import FaturarCliente from '../pages/financeiro/faturarCliente';
import GerarPix from '../pages/financeiro/gerarPix';
import GerarPixLitigio from '../pages/financeiro/gerarPixLitigio';
import LancamentoSPE from '../pages/financeiro/lancamentoSPE.js';
import LancarAcordo from '../pages/financeiro/lancarAcordo';
import LancarAcordoLitigio from '../pages/financeiro/lancarAcordoLitigio';
import LancarPagamentosBradesco from '../pages/financeiro/lancarPagamentoBradesco.js';
import LancarReembolso from '../pages/financeiro/lancarReembolso.js';
import RetencaoCaixaSPE from '../pages/financeiro/retencaoCaixaSPE.js';
import SimularAcordo from '../pages/financeiro/simularAcordo';
import QuitacaoDebitos from '../pages/gestaoEnergia/quitacaoDebitos';

const RouteFinanceiro = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='Financeiro'/>}>
                <Route path='faturarCliente' element={<FaturarCliente/>}/>
                <Route path='criarContrato' element={<CriarContrato/>}/>
                <Route path='gerarPix' element={<GerarPix/>}/>
                <Route path='gerarPixLitigio' element={<GerarPixLitigio/>}/>
                <Route path='lancarAcordo' element={<LancarAcordo/>}/>
                <Route path='lancarAcordoLitigio' element={<LancarAcordoLitigio/>}/>
                <Route path='quitacaoDebitos' element={<QuitacaoDebitos/>}/>
                <Route path='checkSerasaCobranca' element={<CheckSerasaCobranca/>}/>
                <Route path='simularAcordo' element={<SimularAcordo/>}/>
                <Route path='lancamentoSPE' element={<LancamentoSPE/>}/>
                <Route path='retencaoCaixaSPE' element={<RetencaoCaixaSPE/>}/>
                <Route path='lancarPagamentosBradesco' element={<LancarPagamentosBradesco/>}/>
                <Route path='lancarReembolso' element={<LancarReembolso/>}/>
            </Route>
        </Routes>
    );
};

export default RouteFinanceiro;
